export const enum TripOverviewTemplateIds {
  PriceCalendar = 'priceCalendar',
}
